export default __webpack_public_path__ + "static/media/Impugnatio Ultima.4d5dc6af.png";